import type { ResourceListModuleProps } from "./renderProps";
import { renderTextWithLineBreaks } from "./text";

export function ResourceListModule({
  eyebrow,
  heading,
  body,
  items,
}: ResourceListModuleProps) {
  return (
    <section
      className="cms-section cms-resource-list"
      data-cms-module="resource-list"
    >
      <div className="cms-wrap cms-resource-list__layout">
        <div className="cms-resource-list__intro">
          <div className="cms-eyebrow-row">
            <span className="cms-eyebrow">
              {renderTextWithLineBreaks(eyebrow || "Resources")}
            </span>
          </div>
          {heading ? <h2>{renderTextWithLineBreaks(heading)}</h2> : null}
          {body ? <p>{renderTextWithLineBreaks(body)}</p> : null}
        </div>
        <div className="cms-resource-list__items">
          {items.map((item, index) => (
            <article
              className="cms-resource-list__item"
              key={item.title || index}
            >
              <div>
                {item.title ? <h3>{renderTextWithLineBreaks(item.title)}</h3> : null}
                {item.description ? (
                  <p>{renderTextWithLineBreaks(item.description)}</p>
                ) : null}
              </div>
              {item.linkLabel && item.url ? (
                <a href={item.url} rel="noopener noreferrer">
                  {item.linkLabel}
                </a>
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
